/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  NOTIFY_USER: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.govj.csmeCertificateList.notifyUser',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'NOTIFY_USER' },
      },
    },
    NOTIFY_USER: {
      invoke: {
        id: 'notifyUser',
        src: 'notifyUser',
        onDone: {
          target: 'NOTIFY_USER_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'NOTIFY_USER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    NOTIFY_USER_SUCCESS: {
      on: {
        START: { target: 'NOTIFY_USER' },
      },
    },
    NOTIFY_USER_FAILED: {
      on: {
        START: { target: 'NOTIFY_USER' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
